import { curveBasis } from "@visx/curve";
import { AreaClosed, LinePath } from "@visx/shape";
import { ScaleLinear, ScaleTime } from "d3-scale";

import { TimeSeriesData } from "@app/common/types";

const TimeSeriesCurve = ({
  data,
  fill,
  strokeColor,
  xScale,
  yScale,
}: {
  data: TimeSeriesData[];
  fill: string;
  strokeColor: React.CSSProperties["stroke"];
  xScale: ScaleTime<number, number>;
  yScale: ScaleLinear<number, number>;
}) => (
  <>
    <AreaClosed<TimeSeriesData>
      curve={curveBasis}
      data={data}
      yScale={yScale}
      x={(d) => xScale(d.x)}
      y={(d) => yScale(d.y)}
      fill={fill}
    />
    <LinePath<TimeSeriesData>
      curve={curveBasis}
      data={data}
      x={(d) => xScale(d.x)}
      y={(d) => yScale(d.y)}
      strokeWidth={1.5}
      stroke={strokeColor}
    />
  </>
);

export default TimeSeriesCurve;
